import React from "react";
import "./OverView.css";
import { BsCheck2Circle } from "react-icons/bs";

const stats = [
  { value: "40%", label: "Reduction in maintenance costs" },
  { value: "99.9%", label: "Asset visibility accuracy" },
  // { value: "15-day", label: "Free trial available" },
  { value: "6+", label: "Industries served" },
];

const reasons = [
  {
    label: "Single-Platform Control",
    text: "Unified workflows and shared data for seamless administration.",
  },
  {
    label: "Predictive & Intelligent Maintenance",
    text: "Move beyond reactive repairs to maximize reliability and uptime.",
  },
  {
    label: "Fully Configurable",
    text: "Modular applications tailored to your specific infrastructure needs.",
  },
  {
    label: "Superior User Experience",
    text: "Fast implementation and an intuitive interface designed for your team.",
  },
];

const OverView = () => {
  return (
    <section className="Overview py-12 sm:py-16" id="Overview">
      <div className="mx-auto flex max-w-[110rem] flex-col gap-12 px-5 sm:px-14 lg:flex-row lg:gap-16 items-start">
        {/* Left column */}
        <div className="flex min-w-0 flex-1 flex-col gap-8">
          {/* <div className="inline-block rounded-full bg-[#002C78]/10 px-4 py-1 text-xs font-semibold uppercase tracking-wider text-[#002C78] w-fit">
            Overview
          </div> */}

          <h2 className="text-3xl sm:text-4xl lg:text-[2.6rem] font-bold text-[#002C78] leading-tight border-l-4 border-[#F23100] pl-5">
            Intelligent Enterprise Asset Management with iAssetMax™
          </h2>

          <div className="flex flex-col gap-5 text-[#4b5563] text-lg leading-relaxed">
            <p>
              iAssetMax™ is your single-window platform for complete asset lifecycle management—from acquisition
              and deployment to maintenance, inspection, and retirement. Designed to optimize equipment, facilities,
              and infrastructure, iAssetMax™ boosts uptime, reduces operational costs, and powers data-driven
              decisions.
            </p>

            <h3 className="text-2xl font-bold text-[#002C78] mt-2">
              Maximize Value across the Asset Lifecycle
            </h3>
            <p>
              True asset management requires strategic planning, financial precision, and proactive risk control. By
              unifying Enterprise Asset Management (EAM) and Computerized Maintenance Management System
              (CMMS) workflows, iAssetMax™ delivers complete visibility into performance, risk, and reliability.
            </p>

            <h3 className="text-2xl font-bold text-[#002C78] mt-2">
              Why Choose Aargus iAssetMax™?
            </h3>
            <ul className="flex flex-col gap-3.5 pl-1">
              {reasons.map((r) => (
                <li key={r.label} className="flex items-start gap-3">
                  <BsCheck2Circle className="text-[#002C78] mt-1 shrink-0 text-xl font-bold" />
                  <span>
                    <strong className="font-semibold text-[#002C78]">{r.label}:</strong>{" "}
                    {r.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Right: Stats Cards */}
        <aside className="w-full lg:w-[24rem] lg:shrink-0 lg:sticky lg:top-24">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-5">
            {stats.map((s) => (
              <div
                key={s.label}
                className="flex flex-col gap-2 rounded-xl border border-gray-200 bg-gradient-to-br from-white to-[#f8fafc] p-6 shadow-sm transition-all duration-300 hover:shadow-md hover:-translate-y-1 hover:border-[#002C78]/30"
              >
                <span className="text-[2.4rem] font-bold text-[#002C78] tracking-tight">{s.value}</span>
                <span className="text-[0.95rem] font-medium leading-snug text-[#4b5563]">{s.label}</span>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </section>
  );
};

export default OverView;
